export const PDF_HEADER = {
    pt: [
        {
            _id: 'read',
            name: 'Status',
        },
        {
            _id: 'scanDate',
            name: 'Data',
        },
        {
            _id: 'name',
            name: 'Local',
        },
    ],
    en: [
        {
            _id: 'read',
            name: 'Status',
        },
        {
            _id: 'scanDate',
            name: 'Scan date',
        },
        {
            _id: 'name',
            name: 'Patrol point',
        },
    ],
}
